import { Bonus } from '@core/models/bonus/Bonus';
import { Promotion } from '@app/promotionHub/promotions/types/Promotion';

export function isInstanceOfBonus(object: Bonus | Promotion): object is Bonus {
    return 'bonusSubtype' in object;
}

export function isCallToActionTextValid(ctaText: string): boolean {
    return ctaText.length >= 2 && ctaText.length <= 20;
}
